import Table from "../CommonControlls/TableRendrer";
import * as Common from "../CommonControlls/CommonJs";
import React, { useState, useEffect } from 'react';
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";

const HelpDesk_List = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalRecord, setTotalRecord] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(Common.APILinks.HelpDesk_List);
                if (response.ok) {
                    const data = await response.json();

                    if (data && Array.isArray(data)) {
                        const formattedData = data.map(image => ({
                            ...image,
                            viewLink: image.imageUrl,
                        }));
                        setImages(formattedData);
                        setTotalRecord(formattedData.length);
                    } else {
                        setImages([]);
                        setTotalRecord(0);
                    }
                } else {
                    console.error('Error fetching images:', response.statusText);
                    setImages([]);
                    setTotalRecord(0);
                }
            } catch (error) {
                console.error('Error fetching images:', error);
                setImages([]);
                setTotalRecord(0);
            }
        };

        fetchData();
    }, []);


    const columns = [
        {
            dataField: 'title',
            text: 'Title',
        },
        {
            dataField: 'youtubeVideoUrl',
            text: 'YouTube URL',
            formatter: (cell) => cell ? <a href={cell} target="_blank" rel="noopener noreferrer">{cell}</a> : ''
        },
        {
            dataField: 'viewLink',
            text: 'View',
            formatter: (cell, row) => {
                return row.docType === '.pdf' ?
                    <a href={process.env.REACT_APP_API_URL + cell} target="_blank" rel="noopener noreferrer">Open PDF</a> :
                    <a href={process.env.REACT_APP_API_URL + cell} target="_blank" rel="noopener noreferrer">Open Image</a>
            }
        }
    ];

    const handleTableChange = (type, { page, sizePerPage, filters }) => {
       
    };

    const ExportPdf = () => {
      
    };

    const PopulateTable = () => {
        
    };

    return (
        <div>
            <MainLayout />
            <div id="right-panel" className="right-panel">
                <Topmenu
                    PageTitle="Help Module"
                    isShowAddBtn={true}
                    AddBtnLabel="Add Help"
                    AddBtnLink="/HelpDesk_Add"
                />
                <div class="content">
                    <div class="PageHeader_Container">
                        <h2 class="Pageheading">Help Material</h2>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <Table
                                keyField='id'
                                data={images}
                                columns={columns}
                                sizePerPage={20}
                                totalSize={TotalRecord}
                                onTableChange={handleTableChange}
                                exportPdf={ExportPdf}
                                changeSizePerPage={(size) => {
                                    setTimeout(() => {
                                        setLoading(true);
                                       
                                    }, 100)
                                }}
                                isPagination={true}
                                loading={loading}
                                exportAllowed={true}
                                RefreshTable={PopulateTable}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpDesk_List;
